<template>
  <div class="checkout-builder-timer-modal py-3 px-6">
    <div class="d-flex justify-content-between align-items-center mb-6">
      <h3>Cronômetro</h3>
      <button
        class="btn btn-sm py-3 px-4 btn-circle btn-new-secondary"
        @click="$emit('close')"
      >
        <i class="fa fa-close" />
      </button>
    </div>

    <bp-input
      v-model="form.countdownTime"
      number
      class="mb-5"
      id="countdownTime"
      label="Tempo do contador (segundos)"
      placeholder="Tempo em segundos"
      :min="0"
    />

    <!-- <bp-input
      v-model="form.countdownText"
      class="mb-5"
      id="countdownText"
      label="Texto do contador"
      placeholder="Ex.: Essa oferta irá expirar..."
    />

    <form-group
      v-model="form.countdownTextColor"
      color
      label="Cor do texto"
      id="text-color"
      placeholder="Ex.: #000000"
    />

    <form-group
      v-model="form.countdownBackgroundColor"
      color
      class="mb-5"
      label="Cor de fundo"
      id="background-color"
      placeholder="Ex.: #FFFFFF"
    /> -->

    <div class="d-flex flex-column flex-lg-row justify-content-end gap-5">
      <bp-button
        class="order-0 order-lg-1"
        label="Inserir Cronômetro"
        @click="save"
        :disabled="!isValid"
      />
      <bp-button
        color="neutral"
        label="Cancelar"
        variant="filled-1"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...formFields(
        [
          "countdownTime"
          // "countdownText",
          // "countdownTextColor",
          // "countdownBackgroundColor"
        ],
        {
          countdownTime: this.data.countdownTime ?? 0
          // countdownText:
          //   this.data.countdownText ?? "Essa oferta irá expirar...",
          // countdownTextColor: this.data.countdownTextColor ?? "#FFFFFF",
          // countdownBackgroundColor:
          //   this.data.countdownBackgroundColor ?? "#ee6469"
        }
      )
    };
  },
  computed: {
    isValid() {
      return this.form.countdownTime;
    }
  },
  methods: {
    save() {
      this.$emit("save", {
        type: "timer",
        ...this.form
      });
    }
  }
};
</script>
